import AppDataService from "./AppDataService";

const COMMON_BASE = 'ApiHub'

export default class ApiHubDataService {

    static async getApiDetails(){
        return await AppDataService.get(`${COMMON_BASE}/GetApiDetails`);
    }
    static async enableApi(){
        return await AppDataService.post(`${COMMON_BASE}/EnableApi`);
    }
    static async getDeveloperList(data){
        return await AppDataService.post(`${COMMON_BASE}/DeveloperList`, data);
    }
    static async deleteDeveloper(userId){
        return await AppDataService.delete(`${COMMON_BASE}/DeleteDeveloper?UserId=${userId}`,);
    }
    static async inviteDevelopers(emails){
        return await AppDataService.post(`${COMMON_BASE}/CreateDevelopers?email=${emails}`,);
    }
    static async managerShowProdAppKey(data){
        const {userId, action} = data;
        return await AppDataService.put(`${COMMON_BASE}/ManagerShowProdAppKey?UserId=${userId}&Action=${action}`,);
    }
    static async disableApi(){
        return await AppDataService.put(`${COMMON_BASE}/DisableApi`);
    }
    static async requestProdAppKey(){
        return await AppDataService.post(`${COMMON_BASE}/RequestProdAppKey`);
    }
}